import '../scss/user-detail.scss';

import '../offers-list';

